export default __webpack_public_path__ + "66b707641ab62078c31439da57f12755.png";